import { type StateCreator } from 'zustand';

import { type UseTrackCanvasNextActionPillsShownParams } from '@air/analytics';

export type SmartResizeFollowUpScope = { formatIds: string[]; runId: string };

export type NextActionPillId = UseTrackCanvasNextActionPillsShownParams['pill_ids'][number];

export type SmartResizeFollowUpActions = {
  onDownload: (scope: SmartResizeFollowUpScope) => Promise<void>;
  onEditElements: () => void;
  onNextAction: (pillId: NextActionPillId, scope: SmartResizeFollowUpScope) => boolean;
  onPreview: (scope: SmartResizeFollowUpScope) => void;
  onSaveToBoard: (scope: SmartResizeFollowUpScope) => Promise<void>;
};

export type SmartResizeFollowUpActionsSlice = {
  actions: SmartResizeFollowUpActions | null;
  clearPillsShownRunIds: () => void;
  markPillsShown: (runId: string) => void;
  pillsShownRunIds: Record<string, true>;
  popupRunId: string | null;
  setActions: (actions: SmartResizeFollowUpActions | null) => void;
  setPopupRunId: (runId: string | null) => void;
};

export type CreateSmartResizeFollowUpActionsSlice = () => StateCreator<
  SmartResizeFollowUpActionsSlice,
  [],
  [],
  SmartResizeFollowUpActionsSlice
>;

export const createSmartResizeFollowUpActionsSlice: CreateSmartResizeFollowUpActionsSlice = () => (set) => ({
  actions: null,
  clearPillsShownRunIds: () => {
    set({ pillsShownRunIds: {} });
  },
  markPillsShown: (runId) => {
    set((state) => ({ pillsShownRunIds: { ...state.pillsShownRunIds, [runId]: true } }));
  },
  pillsShownRunIds: {},
  popupRunId: null,
  setActions: (actions) => {
    set({ actions });
  },
  setPopupRunId: (popupRunId) => {
    set({ popupRunId });
  },
});
